/* tslint:disable */
/* eslint-disable */
/**
 * Auth Service API
 * Auth Service API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const UpdatePermissionDtoAuthMethodRestrictionEnum = {
    Pin: 'pin'
};
/**
 * Check if a given object implements the UpdatePermissionDto interface.
 */
export function instanceOfUpdatePermissionDto(value) {
    return true;
}
export function UpdatePermissionDtoFromJSON(json) {
    return UpdatePermissionDtoFromJSONTyped(json, false);
}
export function UpdatePermissionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'resource': json['resource'] == null ? undefined : json['resource'],
        'operation': json['operation'] == null ? undefined : json['operation'],
        'authMethodRestriction': json['authMethodRestriction'] == null ? undefined : json['authMethodRestriction'],
    };
}
export function UpdatePermissionDtoToJSON(json) {
    return UpdatePermissionDtoToJSONTyped(json, false);
}
export function UpdatePermissionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'description': value['description'],
        'resource': value['resource'],
        'operation': value['operation'],
        'authMethodRestriction': value['authMethodRestriction'],
    };
}
//# sourceMappingURL=UpdatePermissionDto.js.map